<template>
  <!-- 已删除员工列表 author: zhangxiaofeng -->
  <div class="table-container organization width-full height-full flex flex-column">
    <div class="btn-wrapper flex" id="table-header-wrapper">
      <div class="organization-title">
        组织关系列表
      </div>
      <div class="organization-tabs padding-0-24">
        <div class="w__button-group">
          <w-button :type="type === 'APPLY' ? 'primary' : 'default'" @click="changeType('APPLY')">我加入的</w-button>
          <w-button :type="type === 'CREATE' ? 'primary' : 'default'" @click="changeType('CREATE')">我发起的</w-button>
        </div>
      </div>
      <div class="button-group flex-1 text-align-right">
        <w-button type="primary" @click="handlerJoinOrganization">加入组织关系</w-button>
        <w-button type="primary" @click="handlerLaunchOrganization" style="margin-right: 10px">发起组织关系</w-button>
        <w-form class="inline-block" @submit.native.prevent>
          <w-input
            style="width: 220px"
            clearable
            size="small"
            placeholder="输入组织名称搜索"
            v-model="enterpriseName"
            @keyup.enter.native="handlerSearch"
          >
            <i
              slot="prefix"
              class="w__input__icon r2-icon-action_search"
              style="font-size: 16px !important"
            ></i>
            <i
              v-if="enterpriseName !== ''"
              class="r2-icon-nav_cancel cursor-pointer"
              style="lineHeight: 32px;"
              slot="suffix"
              @click="enterpriseName = '';handlerSearch()">
            </i>
          </w-input>
        </w-form>
      </div>
    </div>
    <div class="table-wrapper block flex-1 relative" id="scrollBody">
      <div class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding absolute height-full"
           id="tree-table" v-loading="loading">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row width-full">
            <div class="header-item is-leaf flex-1">组织名称</div>
            <div class="header-item is-leaf" style="width: 190px;">关系类型</div>
            <div class="header-item is-leaf" style="width: 200px;">创建人</div>
            <div class="header-item is-leaf" style="width: 150px;">创建时间</div>
            <div class="header-item is-leaf is-operate" style="width: 90px;">操作</div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" ref="containerWrapper" v-if="organizationList.length">
            <li class="flex flex-row row row--level-1 width-full" v-for="(item, index) in organizationList"
                :key="index">
              <div class="cell column_1 flex-1">{{type === 'APPLY' ? item.creatorEnterpriseName : item.applyerEnterpriseName}}</div>
              <div class="cell column_2" style="width: 190px;">{{item.relTypeName}}</div>
              <div class="cell column_3" style="width: 200px;">{{item.creatorName}}</div>
              <div class="cell column_4 is-left" style="width: 150px;">
                {{item.gmtCreate | formatDate()}}
              </div>
              <div class="cell column_5 is-operate" style="width: 90px;">
                <div style="width: 100%;">
                  <span class="cursor-pointer color-blue" @click="handlerUnbind(item)">解除</span>
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="absolute text-align-center" style="top: 50%;left: 50%;transform: translate(-50%,-50%);">
            <div class="text-align-center color-white"
                 style="width:56px;height:56px;line-height:56px;background:rgba(33,37,48,0.15);border-radius: 50%;margin: 0 auto;">
              <i class="r2-icon-action_description" style="font-size: 30px;"></i>
            </div>
            <div class="text-align-center font-16 color-999" style="font-size:14px;margin-top: 12px">
              暂无数据
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-box margin-top-10" v-if="total > 0">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="pageNum"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pageSize"
        :page-sizes="[50, 100]"
        :total="total">
      </w-pagination>
    </div>
    <!-- 加入组织关系 -->
    <w-dialog :show="joinConfirm.showJoinConfirm"
              confirm
              @close="joinConfirm.showJoinConfirm = false"
              title="加入组织关系"
              :box-style="{width: 'auto'}"
              :body-style="{width: '532px', boxSizing: 'border-box'}"
              :footer-style="{borderTop: 'none'}">
      <div class="confirm-content">
        <w-form size="small" ref="joinForm" :model="joinConfirm" :rules="joinConfirm.rules" label-width="94px"
                label-position="left" @submit.native.prevent>
          <!--<w-form-item label="输入邀请码" prop="applyCode">-->
            <!--<w-input v-model.trim="joinConfirm.applyCode" maxlength="8" placeholder="请输入邀请码"-->
                     <!--style="width: 318px;margin-right: 12px;"/>-->
            <!--<w-button @click="submitForm" ghost>验证</w-button>-->
          <!--</w-form-item>-->
          <div class="w__form-item w__form-item--small" :class="{'is-error': joinConfirm.errorMessage}" style="margin-bottom: 24px;">
            <label class="w__form-item__label" style="width: 94px;">输入邀请码</label>
            <div class="w__form-item__content" style="margin-left: 94px;line-height: 1;">
              <div class="w__input w__input--small" style="width: 318px; margin-right: 12px;">
                <input type="text" v-model.trim="joinConfirm.applyCode" autocomplete="off" maxlength="8" placeholder="请输入邀请码" class="w__input__inner">
              </div>
              <w-button @click="validateApplyCode()" ghost :disabled="joinConfirm.applyCode.length !== 8">验证</w-button>
              <div class="w__form-item__error ellipsis" style="width: 318px;">
                {{joinConfirm.errorMessage}}
              </div>
            </div>
          </div>
          <!--<w-form-item label="组织名称">-->
            <!--<w-input :value="joinConfirm.creatorEnterpriseName" disabled style="width: 318px;margin-right: 12px;"/>-->
          <!--</w-form-item>-->
          <div class="w__form-item w__form-item--small" style="margin-bottom: 24px;">
            <label class="w__form-item__label" style="width: 94px;">组织名称</label>
            <div class="w__form-item__content" style="margin-left: 94px;line-height: 1;">
              <div class="w__input w__input--small is-disabled" style="width: 318px; margin-right: 12px;">
                <div class="w__input__inner ellipsis">
                  {{joinConfirm.creatorEnterpriseName}}
                </div>
              </div>
            </div>
          </div>
          <w-form-item label="关系类型">
            <w-input :value="joinConfirm.relTypeName" disabled style="width: 318px;margin-right: 12px;"/>
            <el-tooltip class="item" effect="dark" :offset="-7">
              <div slot="content" style="fontSize: 14px;lineHeight:22px;">
                组织关系建立后，关系双方可以邀请<br/>对方组织内的员工参与其业务活动
              </div>
              <i class="w-icon-wenhao header-explain color-default"></i>
            </el-tooltip>
          </w-form-item>
        </w-form>
      </div>
      <div slot="footer">
        <w-button type="primary" @click="joinOrganization" :disabled="!joinConfirm.validPass">确定</w-button>
        <w-button type="minor" @click="joinConfirm.showJoinConfirm = false">取消</w-button>
      </div>
    </w-dialog>
    <!-- 发起组织关系 -->
    <w-dialog :show="launchConfirm.showLaunchConfirm"
              confirm
              @close="launchConfirm.showLaunchConfirm = false"
              class="launch-organization"
              title="发起组织关系"
              :box-style="{width: 'auto'}"
              :body-style="{width: '520px', boxSizing: 'border-box'}"
              :footer-style="{borderTop: 'none'}">
      <div class="confirm-content" v-if="launchConfirm.showApplyCode">
        <div class="tips-text text-align-center">
          请将如下邀请码复制后，发送给对方的管理员，让其创建组织关系<br/>
          该邀请码有效期截止到 {{launchConfirm.gmtCreate | formatDate(24 * 60 * 60 * 1000, 'yyyy-MM-dd hh:mm:ss')}}
        </div>
        <div class="apply-code text-align-center padding-24">
          {{launchConfirm.applyCode}}
        </div>
      </div>
      <div class="confirm-content" v-else>
        <div class="confirm-tips flex">
          <div class="tips-text flex-1">
            组织关系建立后，关系双方可以邀请对方组织内的员工参与其业务活动
          </div>
          <div class="tips-image"></div>
        </div>
        <div>
          <w-form label-width="100px" label-position="left">
            <w-form-item label="组织关系类型">
              <w-checkbox-group v-model="launchConfirm.refType">
                <w-checkbox v-for="relationType in launchConfirm.relationTypes" :label="relationType.relType"
                            :key="relationType.relType">
                  {{relationType.relTypeName}}
                </w-checkbox>
              </w-checkbox-group>
            </w-form-item>
          </w-form>
        </div>
      </div>
      <div slot="footer">
        <template v-if="launchConfirm.showApplyCode">
          <w-button type="primary" @click="copyCode" v-clipboard="{value: launchConfirm.applyCode, success: copyCode}">
            复制邀请码
          </w-button>
        </template>
        <template v-else>
          <w-button type="primary" @click="applyCode" :disabled="launchConfirm.refType.length === 0">生成邀请码</w-button>
        </template>
        <w-button type="minor" @click="launchConfirm.showLaunchConfirm = false">取消</w-button>
      </div>
    </w-dialog>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .organization {
    &.table-container {
      width: 100%;
      height: 100%;
      padding: 24px 25px;
      box-sizing: border-box;

      .btn-wrapper {
        .group-name {
          width: 200px;
          height: 24px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(33, 37, 48, 1);
          line-height: 24px;
        }
      }

      .table-wrapper {
        margin-top: 16px;

        .role-setting {
          i {
            font-size: 12px;
          }
        }

        .w__dropdown-link {
          .more {
            cursor: pointer;

            &:hover {
              color: #1a6dcd;
            }
          }
        }
      }
    }

    .organization-title {
      line-height: 32px;
      font-size: 16px;
      font-weight: bold;
      color: #212530;
    }
  }

  .launch-organization {
    .confirm-content {
      height: 128px;
    }
    .tips-text {
      font-size: 14px;
      color: rgba(33, 37, 48, 0.55);
      line-height: 22px;
      padding-left: 4px;
      cursor: default;
    }

    .tips-image {
      margin-left: 22px;
      width: 181px;
      height: 56px;
      background: url("~@/assets/images/launch-organization.png");
      background-position: center;
      background-size: contain;
    }

    .apply-code {
      font-size: 28px;
      font-weight: bold;
      color: #212530;
      line-height: 36px;
    }
  }
</style>
<script>
import JsEncrypt from 'jsencrypt'
import manageService from '@/assets/service/manage'
import {formatDate} from '@/assets/utils/Date'
import _ from 'lodash'

// rsa加密
const encrypt = new JsEncrypt()
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDd9v+OVxa5ituKgpeyUVHG6oLd15HJsI6UHj7ZcQsrGTJGzA+Gv0LkPwnHBxyqXnaY8gY98KVBGCE/3gfejdT8a9Wx7n7Iu1xPE35WnYzSZ/TuDVzK3bU8HV/EiiVPXEzJQmhmHMwMzUOJJ3+jGkafad/BVs8Pysxdd3uUWkInuQIDAQAB'

export default {
  name: 'Organization',
  data () {
    return {
      pageNum: 1,
      pageSize: 50,
      total: 0,
      scrollY: false,
      loading: false,
      organizationList: [],
      enterpriseName: '',
      type: 'APPLY', // "CREATE 我发起的/APPLY  我加入的"
      // 加入组织关系弹窗
      joinConfirm: {
        showJoinConfirm: false,
        applyCode: '',
        creatorEnterpriseName: '',
        relTypeName: '',
        errorMessage: '',
        validPass: false
      },
      // 发起组织关系弹窗
      launchConfirm: {
        showLaunchConfirm: false,
        relationTypes: [],
        refType: [],
        showApplyCode: false,
        applyCode: '',
        gmtCreate: ''
      }
    }
  },
  filters: {
    formatDate (value, addTime = 0, format = 'yyyy-MM-dd') {
      if (typeof value === 'number') {
        return formatDate(new Date(value + addTime), format)
      }

    }
  },
  mounted () {
    this.type = this.$route.query.type || 'APPLY'
    this.getOrganizationList()
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  methods: {
    // 切换组织关系类型
    changeType (type) {
      const query = this.$route.query
      this.$router.replace({
        path: '/manage/organize/organization',
        query: Object.assign({}, query, {type})
      })
      this.pageNum = 1
      this.organizationList = []
      this.type = type
      this.getOrganizationList()
    },
    // 获取组织关系列表
    getOrganizationList: _.debounce(function () {
      const {pageNum, pageSize, enterpriseName, type} = this
      const name = typeof enterpriseName === 'string' ? enterpriseName.trim() : ''
      this.organizationList = []
      this.total = 0
      this.loading = true
      manageService.getRelationList({pageNum, pageSize, enterpriseName: name, type}).then(res => {
        this.loading = false
        if (res.code === 200) {
          const data = res.data || {}
          let {items = [], totalCount = 0} = data
          this.organizationList = items
          this.total = totalCount
        }
      }).catch(() => {
        this.loading = false
      })
    }, 500),
    // 解除绑定
    handlerUnbind (item) {
      this.sentLog(100117087)
      this.$confirm({
        type: 'warning',
        width: 400,
        message: '操作确认',
        tips: '您确定解除该组织关系吗？',
        bodyStyle: {},
        footerStyle: {},
        submit: () => {
          this.sentLog(100117088)
          this.unbindOrganization(item)
        }
      })
    },
    // 解除组织关系
    unbindOrganization: _.debounce(function (item) {
      const {id, applyerEnterpriseName, creatorEnterpriseName, relTypeName, relType, applyCode} = item
      const enterpriseName = this.type === 'APPLY' ? creatorEnterpriseName : applyerEnterpriseName
      manageService.unbindRelation({id}).then(res => {
        if (res.code === 200) {
          this.$message.success('组织关系解除成功')
          this.getOrganizationList()
          this.addRelationLog({
            applyCode,
            area: this.userInStore.area,
            detail: `${enterpriseName}${enterpriseName ? '-' : ''}${relTypeName}`,
            operateType: 'UNBIND',
            relType,
            showState: 1
          })
        } else {
          this.$message.error('组织关系解除失败')
        }
      }).catch(e => this.$message.error(e.message))
    }, 600),
    // 新增组织关系操作记录
    addRelationLog (params) {
      manageService.addRelationLog(params)
    },
    // 更改页码
    handleCurrentChange (index) {
      this.pageNum = index
      this.getOrganizationList()
    },
    // 更改页面大小
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      this.getOrganizationList()
    },
    // 加入组织关系
    handlerJoinOrganization () {
      this.sentLog(100117084)
      Object.assign(this.joinConfirm, {
        showJoinConfirm: true,
        applyCode: '',
        relTypeName: '',
        creatorEnterpriseName: '',
        errorMessage: '',
        relType: '',
        validPass: false
      })
    },
    // 发起组织关系
    handlerLaunchOrganization () {
      this.sentLog(100117081)
      this.getRelationTypes()
    },
    // 获取企业授信支持的组织关系类型
    getRelationTypes: _.debounce(function () {
      manageService.getRelationTypes().then(res => {
        if (res.code === 200) {
          let data = res.data || []
          data = data.filter(item => (item.showState !== 0))
          if (data.length) {
            Object.assign(this.launchConfirm, {
              relationTypes: data,
              refType: [data[0].relType],
              showLaunchConfirm: true,
              showApplyCode: false
            })
          } else {
            this.$message.error('获取组织关系类型失败，请稍后重试')
          }
        } else {
          this.$message.error('获取组织关系类型失败，请稍后重试')
        }
      }).catch(e => this.$message.error(e.message))
    }, 600),
    // 搜索组织名称
    handlerSearch () {
      this.pageNum = 1
      this.getOrganizationList()
    },
    // 生成邀请码
    applyCode () {
      let refType = this.launchConfirm.refType.toString()
      this.sentLog(100117082, {type: refType})
      manageService.getRelationApplyCode({refType}).then(res => {
        if (res.code === 200) {
          const {applyCode = '', gmtCreate, creatorEnterpriseName = '', relTypeName = '', relType = ''} = res.data || {}
          this.launchConfirm.applyCode = applyCode
          if (gmtCreate) {
            this.launchConfirm.gmtCreate = gmtCreate
          }
          this.launchConfirm.showApplyCode = true
          this.addRelationLog({
            applyCode,
            area: this.userInStore.area,
            detail: `${creatorEnterpriseName}${creatorEnterpriseName ? '-' : ''}${relTypeName}`,
            operateType: 'ADD',
            relType,
            showState: 0
          })
        } else {
          res.message && this.$message.error(res.message)
        }
      })
    },
    // 复制邀请码
    copyCode: _.debounce(function () {
      this.sentLog(100117083)
      this.$message.success('邀请码复制成功')
    }, 600),
    // 验证邀请码
    validateApplyCode: _.debounce(function (cb) {
      manageService.checkApplyCode({applyCode: this.joinConfirm.applyCode}).then(res => {
        if (res.code === 200) {
          const {relTypeName = '', creatorEnterpriseName = '', relType = ''} = res.data || {}
          Object.assign(this.joinConfirm, {
            relTypeName,
            creatorEnterpriseName,
            errorMessage: '',
            relType,
            validPass: true
          })
          if (typeof cb === 'function') {
            cb()
          }
        } else {
          if (typeof cb === 'undefined') {
            this.sentLog(100117085, {message: res.message, code: res.code})
          }
          Object.assign(this.joinConfirm, {
            relTypeName: '',
            creatorEnterpriseName: '',
            errorMessage: res.message,
            relType: '',
            validPass: false
          })
        }
      }).catch(e => {
        this.joinConfirm.errorMessage = e.message
      })
    }, 600),
    // 加入组织
    joinOrganization: _.debounce(function () {
      this.validateApplyCode(() => {
        const {applyCode, creatorEnterpriseName, relTypeName, relType} = this.joinConfirm
        encrypt.setPublicKey(publicKey)
        manageService.createRelation({applyCode: encrypt.encrypt(applyCode)}).then(res => {
          if (res.code === 200) {
            this.sentLog(100117086, {type: 0})
            this.joinConfirm.showJoinConfirm = false
            this.$message.success('组织关系建立成功')
            this.getOrganizationList()
            this.addRelationLog({
              applyCode,
              area: this.userInStore.area,
              detail: `${creatorEnterpriseName}${creatorEnterpriseName ? '-' : ''}${relTypeName}`,
              operateType: 'ADD',
              relType,
              showState: 1
            })
          } else {
            this.sentLog(100117086, {type: 1, message: res.message})
            res.message && this.$message.error(res.message)
          }
        }).catch(e => this.$message.error(e.message))
      })
    }, 600)
  }
}
</script>
